export const productShortName = 'Food Processing Technology & Food Safety — Professional Edition';
export const productBrand = 'Food Processing Technology & Food Safety';
export const productEdition = 'Professional Edition';
export const heroTag = 'Food Processing Technology & Food Safety · Professional Edition';
export const productImage = 'https://cdn.magicpatterns.com/uploads/6YFM5ykuKcakHvsDoQ7gLe/MOCKUP_FOOD.png';
export const productImageAlt =
  'Food Processing Technology & Food Safety Professional Edition: six volumes covering food science fundamentals, processing unit operations, hygiene and sanitation, food microbiology, HACCP and food safety, and quality and audits, plus five bonus resources';

export const checkoutUrl = 'https://food-processing-food-safety.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = 'USD 14.00';
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more confusion about how a food plant fits together, from raw material to the finished pack',
  'No more uncertainty about pasteurization, chilling and time–temperature control',
  'No more gaps in understanding sanitation, CIP and food microbiology',
  'No more confusion about HACCP, prerequisite programs, allergens and traceability',
  'No more feeling lost when a deviation, failed swab or metal detector alarm happens',
];
